import './App.css';
import logo from './static/images/logo.svg'
import cat from './static/images/cat.png'
import linkedn from './static/images/linkedn.png'
import github from './static/images/github.png'
import x from './static/images/x.png'
import github_white from './static/images/github_white.png'
import linkedin_white from './static/images/linkedin_white.png'
import x_white from './static/images/x_white.png'
import { LuDownload } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import {useState, useEffect} from "react";
import { FaCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';
import projects from './data/projects.json';
import FeaturedProject from './featuredProject';
import MusicCard from './musicCard';

function App() {
    const [songs, setSongs] = useState([]);

    useEffect(() => {
        const fetchSongs = () =>
            fetch("https://music-api-omega-eosin.vercel.app/songs")
                .then(res => res.json())
                .then(data => setSongs(data.slice(0, 6)));

        fetchSongs().catch(() =>
            setTimeout(() => fetchSongs().catch(() => {}), 2000)
        );
    }, []);

    const renderProjects = () => {
        return projects
            .filter(p => p.featured)
            .map(project => (
                <FeaturedProject key={`${project.name}-${project.date}`} project={project} />
            ));
    }

    const renderTechStack = () => {
        return Array.from({ length: 9 }, (_, i) => {
            const j = i + 1;
            const animation = j % 2 === 1 ? "tech1" : "tech2";

            return (
                <img
                    key={j}
                    className={`h-16 w-auto ${animation}`}
                    src={require(`./static/images/stack/${j}.png`)}
                    alt={`stack-${j}`}
                />
            );
        });
    };


  return (
    <>
        <div className={"flex flex-col w-full"}>
            <div className={"top-0 sticky w-full flex flex-row justify-center items-center shadow-md z-50 bg-white"}>
                <div className={"flex items-center justify-between w-[90%]"}>
                    <div>
                        <img src={logo} alt="logo" className="h-20 w-20 animate-slide_in_right"/>
                    </div>
                    <div className={"text-sm flex flex-row sm:gap-10 gap-4 font-helios sm:text-xl text-[var(--blue)]"}>
                        <button onClick={() => document.getElementById('aboutme').scrollIntoView({ behavior: 'smooth' })} className={"bio menu-option"}>about.</button>
                        <button onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })} className={"projects menu-option"}>projects.</button>
                        <button onClick={() => document.getElementById('stack').scrollIntoView({ behavior: 'smooth' })} className={"stack menu-option"}>stack.</button>
                    </div>
                </div>
            </div>
            <div className={"w-full flex flex-col items-center mt-14"}>
                <img src={cat} alt="catimage" className="w-40 sm:w-48 h-auto" />
                <p className={"w-[95%] mt-2 text-4xl sm:text-6xl text-center font-helios font-bold text-[var(--blue)] animate-slide_in_up"}> Daniel Herrera Urbano</p>
                <p className={"w-[95%] mt-2 text-2xl sm:text-4xl text-center font-helios font-light text-[var(--blue)] animate-slide_in_up"}> Software Engineer</p>
                <p className={"w-[95%] mt-16 text-xl sm:text-3xl text-center font-helios font-light text-[var(--blue)]"}> It's me, hi!</p>
                <div className={"flex flex-row align gap-6 sm:gap-5 mt-2 sm:mt-3"}>
                    <a href={"https://www.linkedin.com/in/daniel-herrera-urbano-a1170428b"} target="_blank" rel="noopener noreferrer">
                        <img src={linkedn} alt="linkedn" className="w-7 sm:w-8 h-auto icon linkedn" />
                    </a>
                    <a href={"https://github.com/daniherurb"} target="_blank" rel="noopener noreferrer">
                        <img src={github} alt="github" className="w-7 sm:w-8 h-auto icon github" />
                    </a>
                    <a href={"https://x.com/adictware"} target="_blank" rel="noopener noreferrer">
                        <img src={x} alt="x" className="w-7 sm:w-8 h-auto icon x" />
                    </a>
                </div>
                <a href="/daniel_herreraurbano_cv.pdf" download="DanielHerreraUrbano_CV" className={"flex flex-row mt-16 gap-2"}>
                    <LuDownload className={"size-6 mt-[1px] text-[var(--blue)]"}/>
                    <p id="cv" className={"text-md sm:text-lg text-center font-helios font-light text-[var(--blue)] underline"}>
                        download my CV!
                    </p>
                </a>
                <div className={"flex flex-row mt-2 gap-2"}>
                    <MdOutlineEmail className={"size-6 mt-[2px] text-[var(--blue)]"}/>
                    <p className={"text-md sm:text-lg text-center font-helios font-light text-[var(--blue)] underline"}>
                        <a href={"mailto:danielherurb@gmail.com"}>danielherurb@gmail.com</a>
                    </p>
                </div>
            </div>
            <div className={"w-full flex flex-col items-center mt-24"}>
                <p className={"w-[85%] mt-2 mb-4 text-xl sm:text-2xl font-helios font-bold text-[var(--blue)] section-title"} id="aboutme">about me</p>
                <p className={"w-[85%] text-sm sm:text-base font-helios text-justify text-[var(--blue)]"}>
                    I’m Daniel, a Software Engineering student passionate about <b>web development</b>, especially <b>frontend
                    engineering</b> and <b>UI/UX design</b>. I also have experience
                    developing <b>APIs</b> and working with <b>backend</b> systems.<br/>
                    <br/>
                    My interest in frontend started early, back in high school when I built my first static HTML pages.
                    Since then, I’ve become convinced that visual quality, usability, and accessibility are essential to
                    delivering meaningful user experiences. I enjoy creating interfaces that not only look good but
                    genuinely improve how people interact with an application.
                </p>
            </div>
            <div className={"w-full flex flex-col items-center mt-16 mb-10"}>
                <div className={"w-[85%] text-xl sm:text-2xl font-helios font-bold text-[var(--blue)] section-title flex flex-row justify-between"} id="projects">
                    <p>projects</p>
                    <p>
                        <Link to="/projects" className={"font-helios text-sm sm:text-md text-[var(--blue)] underline menu-option self-start"}>
                            see all projects
                        </Link>
                    </p>
                </div>
                <div className={"w-[85%] h-fit flex flex-col lg:flex-row items-stretch gap-12 lg:gap-5 pb-2 pt-4"}>
                    {renderProjects()}
                </div>
            </div>
            <div className={"w-full flex flex-col items-center mt-12"}>
                <p className={"w-[85%] mt-2 mb-4 text-xl sm:text-2xl font-helios font-bold text-[var(--blue)] section-title"} id="stack">stack</p>
                <div className="w-[80%] lg:w-[85%] mt-2 grid grid-cols-3 lg:grid-cols-9 gap-y-10 gap-x-5 justify-items-center">
                    {renderTechStack()}
                </div>
            </div>
            {songs.length > 0 && <div className={"w-full flex flex-col items-center mt-12 mb-10"}>
                <p className={"w-[85%] mt-2 mb-3 text-xl sm:text-2xl font-helios font-bold text-[var(--blue)] section-title"} id="music">music</p>
                <p className={"w-[85%] text-sm sm:text-base font-helios font-light text-[var(--blue)] mb-6"}>
                    I built a small API with <b>Hono</b> to integrate with <b>Spotify</b> — partly as a fun side project, partly because I'm a huge music fan and believe what we listen to says a lot about who we are. Here are 6 songs I've had on repeat lately (or just love deeply).
                </p>
                <div className={"w-[85%] grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6"}>
                    {songs.map(song => (
                        <MusicCard key={song._id} song={song} />
                    ))}
                </div>
            </div>}
            <div className={"w-full h-52 flex flex-col items-center mt-12 justify-between p-3 pb-2 bg-[var(--blue)] font-helios text-white"}>
                <div className={"flex flex-col items-center mt-2"}>
                    <p className={"mt-2 text-lg sm:text-2xl text-center font-helios font-light text-white"}> Daniel Herrera Urbano</p>
                    <p className={"text-sm sm:text-lg text-center font-helios font-light text-white"}> (the CSS/mockups guy, according to some)</p>
                    <div className={"flex flex-row items-center gap-2 mt-4"}>
                        <FaCircle className={"text-green-600 text-sm"}/>
                        <p className={"text-sm sm:text-md"}>I am <b>currently available</b>, contact me!</p>
                    </div>
                    <div className={"flex flex-row align gap-6 sm:gap-5 mt-2 sm:mt-3"}>
                        <a href={"https://www.linkedin.com/in/daniel-herrera-urbano-a1170428b"} target="_blank" rel="noopener noreferrer">
                            <img src={linkedin_white} alt="linkedn" className="w-7 sm:w-8 h-auto icon linkedn" />
                        </a>
                        <a href={"https://github.com/daniherurb"} target="_blank" rel="noopener noreferrer">
                            <img src={github_white} alt="github" className="w-7 sm:w-8 h-auto icon github" />
                        </a>
                        <a href={"https://x.com/adictware"} target="_blank" rel="noopener noreferrer">
                            <img src={x_white} alt="x" className="w-7 sm:w-8 h-auto icon x" />
                        </a>
                    </div>
                </div>
                <p>from the desk of <a href={"https://www.github.com/daniherurb"}>@daniherurb</a></p>
            </div>
        </div>
    </>
  );
}

export default App;
